/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Table_OptionInputs */



/**
* | output |
* | --- |
* | "Option" |
*
* @param {Options_Cli_Table_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_table_option = /** @type {((inputs?: Options_Cli_Table_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Table_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Option")
	if (locale === "de") return /** @type {LocalizedString} */ ("Option")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вариант")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opção")
	return /** @type {LocalizedString} */ ("Option")
});